import ProductLayout from '../ProductLayout'

const WeSaw = ({ isConnected }: { isConnected: boolean }) => {
  return <ProductLayout isConnected={isConnected} productName="WeSaw" biReportNames={['Sawing', 'Sciage']} />
}

export default WeSaw
